import * as React from 'react';

function SvgPortraitLl(props) {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#38B2A6" cx={12} cy={12} r={12} />
        <path
          d="M10.484 11L5.5 13.694V18h4.984zM11.5 6h6v12h-6V6zm2 2v2.03h2V8h-2zm0 3v2.03h2V11h-2z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgPortraitLl;
